@mixin header {
  font-size: 25px;
  @media (min-width: 768px) and (max-width: 1100px) {
    font-size: 22px;
  }
  font-weight: lighter;
  letter-spacing: 1px;
  .fa-info-circle {
    font-size: 15px;
    @media (min-width: 768px) and (max-width: 1100px) {
    }
    margin-left: 7px;
    margin-right: 0 !important;
    position: relative;
    bottom: 2px;
    cursor: pointer;
  }
}

.settings {
  @media (min-width: 767px) {
    overflow-y: auto;
    overflow-x: hidden;
  }
  @media (max-width: 767px) {
    height: auto !important;
  }
  .header {
    @include header;
  }
  .scrollable {
    overflow-x: hidden;
    overflow-y: auto;
  }
}



// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/recipe/drink-settings/drink-settings.scss